/**
 * 海报模块统一卡片容器 + Section 头部 — 三个入口共用 (FreeCreatePage / BrandAssetsEditor / ApplyTemplateSheet)。
 *
 * Token 锁定 (跟 ApplyTemplateSheet 原始风格对齐):
 *   - PosterCard:       rounded-2xl + border-border/60 + bg-card/40
 *   - PosterCardHeader: px-5 + pb-3 + pt-5
 *   - PosterSectionTitle: 1px primary 圆点 + text-sm font-semibold + 灰 hint
 *
 * 任何海报相关页 / sheet 内的"卡片分区"应统一用这套,避免设计语言漂移。
 */
import { cn } from "@/shared/lib/utils";

export function PosterCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "overflow-hidden rounded-2xl border border-border/60 bg-card/40 fx-enter",
        className
      )}
    >
      {children}
    </div>
  );
}

export function PosterCardHeader({ children }: { children: React.ReactNode }) {
  return <div className="px-5 pb-3 pt-5">{children}</div>;
}

export function PosterSectionTitle({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="flex items-center gap-2">
      <span className="h-1 w-1 rounded-full bg-primary" />
      <span className="text-sm font-semibold">{title}</span>
      {hint && <span className="text-xs text-muted-foreground">· {hint}</span>}
    </div>
  );
}
